<template>
  <div class="admin-container">
    <h3>인생의 역점 관리자 페이지</h3>

    <div class="tabs">
      <div
        v-for="tab in tabs"
        :key="tab.key"
        :class="['tab', { active: currentTab === tab.key }]"
        @click="currentTab = tab.key"
      >
        {{ tab.label }}
      </div>
    </div>

    <div class="admin-content">
      <component :is="tabComponent" />
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue'
  import AdminUsers from '@/components/admin/AdminUsers.vue'
  import AdminPosts from '@/components/admin/AdminPosts.vue'
  import AdminStatistics from '@/components/admin/AdminStatistics.vue'

  const currentTab = ref('users')

  const tabs = [
    { key: 'users', label: '사용자', component: AdminUsers },
    { key: 'posts', label: '게시글', component: AdminPosts },
    { key: 'rewards', label: '서비스현황', component: AdminStatistics },
  ]

  const tabComponent = computed(() => {
    const found = tabs.find((t) => t.key === currentTab.value)
    return found?.component || AdminUsers
  })
</script>

<style scoped>
  .admin-container {
    padding: 1rem;
    width: var(--device-width);
    max-width: 480px;
    margin: 0 auto;
  }
  h2 {
    text-align: center;
    margin-bottom: 1rem;
  }
  .tabs {
    display: flex;
    justify-content: space-around;
    border-bottom: 2px solid #ddd;
  }
  .tab {
    padding: 0.5rem 1rem;
    cursor: pointer;
    border-bottom: 3px solid transparent;
  }
  .tab.active {
    font-weight: bold;
    border-color: #4caf50;
  }
  .admin-content {
    margin-top: 1.5rem;
  }
</style>
